import { Link } from 'gatsby';
import React from 'react';
import ContactForm from '../../components/ContactForm/ContactForm';
import CookieModal from '../../components/CookieModal/CookieModal';
import ELChLogo from '../../components/ELChLogo/ELChLogo';
import Seasonal from '../../components/Seasonal/Seasonal';

interface LayoutProps {
  banner?: React.ReactNode;
  showContactFormFooter?: boolean;
}

const DefaultLayout = ({
  children,
  banner,
  showContactFormFooter = true
}: React.PropsWithChildren<LayoutProps>) => {
  return (
    <div>
      <div id="page-wrapper">
        <header id="header">
          <ELChLogo isLink />
          <nav>
            <Link to="/ueberuns">Über Uns</Link>
            <Link to="/projekte">Projekte</Link>
            <Link to="/kontakt">Kontakt</Link>
          </nav>
        </header>

        {/* <nav id="menu">
          <div className="inner">
            <h2>Menu</h2>
            <ul className="links">
              <li>
                <Link to="index.html">Home</Link>
              </li>
              <li>
                <Link to="generic.html">Generic</Link>
              </li>
              <li>
                <Link to="elements.html">Elements</Link>
              </li>
              <li>
                <Link to="#">Log In</Link>
              </li>
              <li>
                <Link to="#">Sign Up</Link>
              </li>
            </ul>
            <Link to="#" className="close" style={{ backgroundImage: close }}>
              Close
            </Link>
          </div>
        </nav> */}

        {banner && <section id="banner">{banner}</section>}

        <section id="wrapper" className="inner">
          {children}
        </section>
        <footer id="sfxContainer">
          <div className="inner">
            {showContactFormFooter && <ContactForm />}
            <ul className="copyright">
              <li>
                <Link to="/impressum">Impressum</Link>
              </li>
              <li>
                <Link to="/datenschutz">Datenschutz und Cookies</Link>
              </li>
              <li>
                <Link to="/kontakt">Kontakt</Link>
              </li>
              <li>&copy; ELCh Digital GmbH. 2025.</li>
            </ul>
          </div>
        </footer>
      </div>
      <Seasonal />
      <CookieModal />
    </div>
  );
};

export default DefaultLayout;
